// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPolicyPage_page__DQ55j","container":"PrivacyPolicyPage_container__lbt0D"};